import { render, staticRenderFns } from "./MUploader.vue?vue&type=template&id=65142b43&scoped=true&"
import script from "./MUploader.vue?vue&type=script&lang=js&"
export * from "./MUploader.vue?vue&type=script&lang=js&"
import style0 from "./MUploader.vue?vue&type=style&index=0&id=65142b43&lang=scss&scoped=true&"
import style1 from "./MUploader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65142b43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VList,VListItem})
